<template>
	<section class="new-event-flight-reservation">
		<div class="new-event-flight-reservation__inner">
			<header class="new-event-flight-reservation__header">
				<h2>{{title}}</h2>
				<p>{{introText}}</p>
			</header>

			<div class="new-event-flight-reservation__divider"></div>

			<flight-request-online
				v-if="isOnlineRequestAvailable"
				:event="event"
				@close="$emit('close')"
			/>
			<flight-request-offline
				v-else
				:event="event"
				@close="$emit('close')"
			/>

			<form
				v-if="false"
				class="new-event-flight-reservation__online-form"
				@submit.prevent="goToWoobaFlightsPage"
			>
				<section class="new-event-flight-reservation__form-intro">
					<button
						type="button"
						class="new-event-flight-reservation__toggle"
						:aria-label="onlineTranslation.flightReservationTitle"
					>
						<span></span>
					</button>
					<h3>{{onlineTranslation.flightReservationTitle}}</h3>
				</section>

				<div class="new-event-flight-reservation__online-grid">
					<div class="new-event-flight-reservation__field">
						<label>{{onlineTranslation.origin}}</label>
						<autocomplete
							v-model="onlineReservation.origin"
							class="new-event-flight-reservation__autocomplete"
							:class="{'new-event-flight-reservation__input--invalid': onlineTouched && !onlineReservation.origin}"
							:options="debounce(findAirports, 300)"
							track-by="initials"
							label-by="label"
							:placeholder="onlineTranslation.originPlaceholder"
						/>
					</div>

					<div class="new-event-flight-reservation__field">
						<label>{{onlineTranslation.destination}}</label>
						<autocomplete
							v-model="onlineReservation.destination"
							class="new-event-flight-reservation__autocomplete"
							:class="{'new-event-flight-reservation__input--invalid': onlineTouched && !onlineReservation.destination}"
							:options="debounce(findAirports, 300)"
							track-by="initials"
							label-by="label"
							:placeholder="onlineTranslation.destinationPlaceholder"
						/>
					</div>

					<div class="new-event-flight-reservation__field">
						<label>{{onlineTranslation.departureDate}}</label>
						<date-picker
							v-model="onlineReservation.checkin"
							class="new-event-flight-reservation__date"
							:initialDefaultDate="initialDefaultDate"
							:invalid="onlineTouched && !onlineReservation.checkin"
						/>
					</div>

					<div class="new-event-flight-reservation__field">
						<label>{{onlineTranslation.returnDate}}</label>
						<date-picker
							v-model="onlineReservation.checkout"
							class="new-event-flight-reservation__date"
							:initialDefaultDate="initialDefaultDate"
						/>
					</div>

					<div class="new-event-flight-reservation__passengers">
						<div class="new-event-flight-reservation__counter">
							<label>{{onlineTranslation.adults}}</label>
							<blm-number-input v-model="onlineReservation.adults" :min="1" :max="9"/>
						</div>

						<div class="new-event-flight-reservation__counter">
							<label>{{onlineTranslation.children}}</label>
							<blm-number-input v-model="onlineReservation.kids" :min="0" :max="9"/>
						</div>

						<div class="new-event-flight-reservation__counter">
							<label>{{onlineTranslation.babies}}</label>
							<blm-number-input v-model="onlineReservation.babies" :min="0" :max="9"/>
						</div>
					</div>
				</div>

				<div class="new-event-flight-reservation__actions">
					<button type="button" class="new-event-flight-reservation__button new-event-flight-reservation__button--secondary" @click="$emit('close')">
						voltar
					</button>
					<button type="submit" class="new-event-flight-reservation__button new-event-flight-reservation__button--primary">
						{{onlineTranslation.continueButton}}
					</button>
				</div>
			</form>

			<div v-if="false">
				<section class="new-event-flight-reservation__form-intro">
					<button
						type="button"
						class="new-event-flight-reservation__toggle"
						:aria-label="offlineTranslation.formTitle"
					>
						<span></span>
					</button>
					<h3>{{offlineTranslation.formTitle}}</h3>
					<p>{{offlineTranslation.descriptionForm}}</p>
				</section>

				<form class="new-event-flight-reservation__offline-form" @submit.prevent="sendOfflineReservation">
					<h4>{{offlineTranslation.personalDetails}}</h4>

					<div class="new-event-flight-reservation__field new-event-flight-reservation__field--full">
						<b-form-input
							v-model="offlineReservation.pax.name"
							class="new-event-flight-reservation__control"
							type="text"
							:placeholder="readableLabel(offlineTranslation.fullName)"
							required
						/>
					</div>

					<div class="new-event-flight-reservation__field">
						<b-form-input
							v-model="offlineReservation.pax.phone"
							class="new-event-flight-reservation__control"
							type="tel"
							:placeholder="readableLabel(offlineTranslation.phone)"
							required
						/>
					</div>

					<div class="new-event-flight-reservation__field">
						<b-form-input
							v-model="offlineReservation.pax.email"
							class="new-event-flight-reservation__control"
							type="email"
							:placeholder="readableLabel(offlineTranslation.email)"
							required
						/>
					</div>

					<div class="new-event-flight-reservation__field">
						<label>{{readableLabel(offlineTranslation.departureAirport)}}</label>
						<autocomplete
							ref="departureAutocomplete"
							v-model="offlineReservation.airport"
							class="new-event-flight-reservation__autocomplete"
							:options="debounce(findAirports, 300)"
							track-by="initials"
							label-by="label"
							:placeholder="offlineTranslation.originPlaceholder"
						/>
					</div>

					<div class="new-event-flight-reservation__field new-event-flight-reservation__field--class">
						<b-form-input
							v-model="offlineReservation.flightClass"
							class="new-event-flight-reservation__control new-event-flight-reservation__control--accent"
							type="text"
							:placeholder="readableLabel(offlineTranslation.class)"
						/>
					</div>

					<div class="new-event-flight-reservation__dates">
						<div class="new-event-flight-reservation__date-group">
							<date-picker
								v-model="offlineDepartureDate"
								class="new-event-flight-reservation__date"
								:initialDefaultDate="initialDefaultDate"
								:placeholder="readableLabel(offlineTranslation.departureDate)"
								required
							/>
							<div class="new-event-flight-reservation__periods">
								<label>
									<input type="radio" v-model="offlineReservation.departurePeriod" :value="Period.MOURNING.name">
									{{offlineTranslation.mourning}}
								</label>
								<label>
									<input type="radio" v-model="offlineReservation.departurePeriod" :value="Period.AFTERNOON.name">
									{{offlineTranslation.afternoon}}
								</label>
								<label>
									<input type="radio" v-model="offlineReservation.departurePeriod" :value="Period.EVENING.name">
									{{offlineTranslation.evening}}
								</label>
							</div>
						</div>

						<div class="new-event-flight-reservation__date-group">
							<date-picker
								v-model="offlineReturnDate"
								class="new-event-flight-reservation__date"
								:initialDefaultDate="initialDefaultDate"
								:placeholder="readableLabel(offlineTranslation.returnDate)"
								required
							/>
							<div class="new-event-flight-reservation__periods">
								<label>
									<input type="radio" v-model="offlineReservation.returnPeriod" :value="Period.MOURNING.name">
									{{offlineTranslation.mourning}}
								</label>
								<label>
									<input type="radio" v-model="offlineReservation.returnPeriod" :value="Period.AFTERNOON.name">
									{{offlineTranslation.afternoon}}
								</label>
								<label>
									<input type="radio" v-model="offlineReservation.returnPeriod" :value="Period.EVENING.name">
									{{offlineTranslation.evening}}
								</label>
							</div>
						</div>
					</div>

					<div class="new-event-flight-reservation__actions">
						<button type="button" class="new-event-flight-reservation__button new-event-flight-reservation__button--secondary" @click="$emit('close')">
							voltar
						</button>
						<button type="submit" class="new-event-flight-reservation__button new-event-flight-reservation__button--primary">
							{{offlineTranslation.send}}
						</button>
					</div>
				</form>
			</div>
		</div>
	</section>
</template>

<script>
import moment from 'moment';
import debounce from 'debounce-promise';
import { translate } from '../../assets/translations';
import AirportService from '../../services/AirportService';
import Autocomplete from '../shared/Autocomplete.vue';
import BlmNumberInput from '../shared/BlmNumberInput.vue';
import ConclusionModal from '../shared/ConclusionModal.vue';
import DatePicker from '../shared/DatePicker.vue';
import EventService from '../../services/EventService';
import FlightRequestOffline from '../../model/FlightRequestOffline';
import Language from '../../enums/Language';
import Period from '../../enums/Period';
import WaitModal from '../shared/WaitModal.vue';
import FlightRequestOfflineComponent from './FlightRequestOffline.vue';
import FlightRequestOnlineComponent from './FlightRequestOnline.vue';

export default {
	components: {
		Autocomplete,
		BlmNumberInput,
		ConclusionModal,
		DatePicker,
		FlightRequestOffline: FlightRequestOfflineComponent,
		FlightRequestOnline: FlightRequestOnlineComponent,
		WaitModal,
	},
	props: {
		event: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			Language,
			Period,
			onlineTouched: false,
			onlineReservation: {
				origin: undefined,
				destination: undefined,
				checkin: null,
				checkout: null,
				adults: 1,
				kids: 0,
				babies: 0,
			},
			offlineDepartureDate: null,
			offlineReturnDate: null,
			offlineReservation: new FlightRequestOffline(),
			airportService: new AirportService(),
			eventService: new EventService(),
		};
	},
	computed: {
		onlineTranslation() {
			return translate(this.$store.state.language).flightReservation;
		},
		offlineTranslation() {
			return translate(this.$store.state.language).flightRequestOffline;
		},
		title() {
			return translate(this.$store.state.language).eventPage.optionLabels.flightReservation;
		},
		introText() {
			const text = this.offlineTranslation.description || '';
			if (!this.event || this.event.maxFlightDiscount <= 0) return `${text}.`;
			return `${text}${this.offlineTranslation.with}${this.offlineTranslation.discount}${this.event.maxFlightDiscount}X`;
		},
		isOnlineRequestAvailable() {
			return this.$store.state.language.id === this.Language.PORTUGUESE.id && Boolean(this.event && this.event.woobaId);
		},
		initialDefaultDate() {
			if (this.event && this.event.startDate) {
				return moment(this.event.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
			}
			return moment().format('DD/MM/YYYY');
		},
		onlineReservationParams() {
			return {
				shortName: this.event.shortName,
				event: this.event,
				...this.onlineReservation,
				origin: this.onlineReservation.origin.initials,
				destination: this.onlineReservation.destination.initials,
				checkin: moment(this.onlineReservation.checkin).format('DD/MM/YYYY'),
				checkout: this.onlineReservation.checkout ? moment(this.onlineReservation.checkout).format('DD/MM/YYYY') : null,
			};
		},
	},
	methods: {
		debounce,
		findAirports(query) {
			return this.airportService.findAirports(query).then(res => res.data);
		},
		readableLabel(label) {
			return String(label || '')
				.toLowerCase()
				.replace(/(^|\s|-)\S/g, letter => letter.toUpperCase());
		},
		isOnlineReservationValid() {
			return Boolean(
				this.onlineReservation.origin
				&& this.onlineReservation.destination
				&& this.onlineReservation.checkin
				&& this.onlineReservation.adults >= 1
			);
		},
		goToWoobaFlightsPage() {
			this.onlineTouched = true;
			if (!this.isOnlineReservationValid()) return;
			this.$router.push({ name: 'flight-reservation', params: this.onlineReservationParams });
		},
		formatDate(date) {
			return moment(date).format('DD/MM/YYYY');
		},
		isOfflineDateRangeInvalid() {
			return !this.offlineDepartureDate || !this.offlineReturnDate || !(this.offlineDepartureDate < this.offlineReturnDate);
		},
		cleanOfflineForm() {
			if (this.$refs.departureAutocomplete) this.$refs.departureAutocomplete.clear();
			this.offlineReservation = new FlightRequestOffline();
			this.offlineDepartureDate = null;
			this.offlineReturnDate = null;
		},
		sendOfflineReservation() {
			if (this.isOfflineDateRangeInvalid()) {
				alert(this.offlineTranslation.invalidDate);
				return;
			}

			const conclusion = this.offlineTranslation.conclusion;
			let sendConclusion = true;
			let title = conclusion.success.title;
			let message = conclusion.success.message;

			this.offlineReservation.departureDate = this.formatDate(this.offlineDepartureDate);
			this.offlineReservation.returnDate = this.formatDate(this.offlineReturnDate);

			this.$refs.waitModal.open(this.offlineTranslation.wait);
			this.eventService.sendFlightReservation(this.event.id, this.offlineReservation)
				.then(() => this.cleanOfflineForm())
				.catch(() => {
					sendConclusion = false;
					title = conclusion.fail.title;
					message = conclusion.fail.message;
				})
				.finally(() => {
					this.$refs.conclusionModal.open(sendConclusion, title, message);
					this.$refs.waitModal.close();
				});
		},
	},
};
</script>

<style lang="scss">
.new-event-flight-reservation {
	color: #002c41;
}

.new-event-flight-reservation__inner {
	box-sizing: border-box;
	width: calc(100% - 196px);
	max-width: 1530px;
	min-height: 953px;
	margin: 0 auto 142px;
	padding: 62px 71px 72px;
	border: 1px solid rgba(154, 149, 149, .25);
	border-radius: 30px;
	background: #eeeeee;
}

.new-event-flight-reservation__header h2 {
	margin: 0 0 22px;
	font-size: 20px;
	font-weight: 900;
	line-height: 24px;
}

.new-event-flight-reservation__header p,
.new-event-flight-reservation__form-intro p {
	margin: 0;
	color: #4c4b4b;
	font-size: 14px;
	font-weight: 400;
	line-height: 19px;
}

.new-event-flight-reservation__divider {
	width: 100%;
	height: 1px;
	margin: 64px 0 42px;
	background: rgba(154, 149, 149, .35);
}

.new-event-flight-reservation__form-intro {
	margin-bottom: 68px;
}

.new-event-flight-reservation__toggle {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 22px;
	height: 22px;
	margin: 0 0 15px;
	padding: 0;
	border: 0;
	background: transparent;
	cursor: default;
}

.new-event-flight-reservation__toggle span {
	display: block;
	width: 16px;
	height: 16px;
	border-right: 3px solid #5da3bd;
	border-bottom: 3px solid #5da3bd;
	transform: rotate(45deg) translateY(-4px);
}

.new-event-flight-reservation__form-intro h3,
.new-event-flight-reservation__offline-form h4 {
	margin: 0 0 21px;
	color: #002c41;
	font-size: 14px;
	font-weight: 900;
	line-height: 16px;
}

.new-event-flight-reservation__online-form,
.new-event-flight-reservation__offline-form {
	max-width: 967px;
}

.new-event-flight-reservation__online-grid,
.new-event-flight-reservation__offline-form {
	display: flex;
	flex-wrap: wrap;
	gap: 16px 17px;
}

.new-event-flight-reservation__offline-form h4,
.new-event-flight-reservation__field--full,
.new-event-flight-reservation__dates,
.new-event-flight-reservation__passengers,
.new-event-flight-reservation__actions {
	flex: 0 0 100% !important;
}

.new-event-flight-reservation__field {
	flex: 1 1 calc(50% - 9px);
	min-width: 0;
}

.new-event-flight-reservation__field--class {
	align-self: end;
}

.new-event-flight-reservation__field label,
.new-event-flight-reservation__counter label {
	display: block;
	margin: 0 0 9px;
	color: #4c4b4b;
	font-size: 12px;
	font-weight: 400;
	line-height: 14px;
}

.new-event-flight-reservation__control,
.new-event-flight-reservation .form-control,
.new-event-flight-reservation__autocomplete input,
.new-event-flight-reservation .new-event-flight-reservation__date .datetime-input {
	display: block;
	box-sizing: border-box;
	width: 100%;
	height: 53px !important;
	padding: 0 16px;
	border: 1px solid #ced4da;
	border-radius: 6px;
	background: #ffffff;
	background-clip: padding-box;
	color: #4c4b4b;
	font-family: inherit;
	font-size: 14px;
	font-weight: 400;
	line-height: 18px;
	outline: none;
	box-shadow: none;
	transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.new-event-flight-reservation__control:focus,
.new-event-flight-reservation .form-control:focus,
.new-event-flight-reservation__autocomplete input:focus,
.new-event-flight-reservation .new-event-flight-reservation__date .datetime-input:focus {
	border-color: #66acc6;
	box-shadow: 0 0 0 .2rem rgba(102, 172, 198, .15);
}

.new-event-flight-reservation .form-control:disabled,
.new-event-flight-reservation .form-control[readonly] {
	background-color: #e9ecef;
	opacity: 1;
}

.new-event-flight-reservation__input--invalid input,
.new-event-flight-reservation .new-event-flight-reservation__date .invalid,
.new-event-flight-reservation .form-control.is-invalid {
	border-color: #e89127;
}

.new-event-flight-reservation__control::placeholder,
.new-event-flight-reservation .form-control::placeholder,
.new-event-flight-reservation__autocomplete input::placeholder {
	color: #6c757d;
	opacity: 1;
}

.new-event-flight-reservation__control--accent::placeholder,
.new-event-flight-reservation__autocomplete input::placeholder,
.new-event-flight-reservation .new-event-flight-reservation__date .datetime-input::placeholder {
	color: #5da3bd;
	opacity: 1;
}

.new-event-flight-reservation__autocomplete .options {
	box-sizing: border-box;
	border: 1px solid #d9d9d9;
	border-top: 0;
	border-radius: 0 0 5px 5px;
	box-shadow: 0 8px 18px rgba(0, 0, 0, .08);
}

.new-event-flight-reservation__autocomplete .option {
	padding: 8px 12px;
	color: #4c4b4b;
	font-size: 13px;
}

.new-event-flight-reservation__dates {
	display: flex;
	gap: 16px;
	align-items: flex-start;
	margin-top: 7px;
}

.new-event-flight-reservation__date-group {
	width: 225px;
}

.new-event-flight-reservation__date {
	width: 100%;
}

.new-event-flight-reservation .new-event-flight-reservation__date .calendar-icon {
	width: 26px;
	right: 12px;
	bottom: 13px;
}

.new-event-flight-reservation__periods {
	display: flex;
	flex-direction: column;
	gap: 7px;
	margin-top: 16px;
	color: #4c4b4b;
	font-size: 13px;
	font-weight: 400;
	line-height: 16px;
}

.new-event-flight-reservation__periods label {
	display: flex;
	align-items: center;
	gap: 6px;
}

.new-event-flight-reservation__periods input {
	width: 13px;
	height: 13px;
	margin: 0;
}

.new-event-flight-reservation__passengers {
	display: flex;
	flex-wrap: wrap;
	gap: 17px;
	margin-top: 7px;
}

.new-event-flight-reservation__counter {
	box-sizing: border-box;
	min-width: 140px;
	padding: 15px 17px;
	border: 1px solid #d9d9d9;
	border-radius: 5px;
	background: #ffffff;
}

.new-event-flight-reservation__counter .number-control {
	border-color: #5da3bd;
	color: #5da3bd;
}

.new-event-flight-reservation__counter .number {
	min-width: 22px;
	justify-content: center;
	color: #4c4b4b;
	font-size: 15px;
	font-weight: 700;
}

.new-event-flight-reservation__actions {
	display: flex;
	justify-content: flex-end;
	gap: 17px;
	margin-top: 46px;
}

.new-event-flight-reservation__offline-form .new-event-flight-reservation__actions {
	margin-top: -14px;
}

.new-event-flight-reservation__button {
	box-sizing: border-box;
	width: 192px;
	height: 34px;
	border-radius: 5px;
	font-family: inherit;
	font-size: 11px;
	font-weight: 700;
	line-height: 13px;
	text-align: center;
	cursor: pointer;
}

.new-event-flight-reservation__button--secondary {
	border: 2px solid #e89127;
	background: #ffffff;
	color: #e89127;
}

.new-event-flight-reservation__button--primary {
	border: 2px solid #e89127;
	background: #e89127;
	color: #ffffff;
}

@media (max-width: 900px) {
	.new-event-flight-reservation__inner {
		width: 90%;
		min-height: 0;
		margin-bottom: 72px;
		padding: 42px 22px 48px;
	}

	.new-event-flight-reservation__divider {
		margin: 42px 0 32px;
	}

	.new-event-flight-reservation__form-intro {
		margin-bottom: 42px;
	}

	.new-event-flight-reservation__online-grid,
	.new-event-flight-reservation__offline-form {
		max-width: none;
	}

	.new-event-flight-reservation__field {
		flex-basis: 100%;
	}

	.new-event-flight-reservation__dates {
		flex-direction: column;
	}

	.new-event-flight-reservation__date-group {
		width: 100%;
	}

	.new-event-flight-reservation__actions {
		flex-wrap: wrap;
		justify-content: flex-start;
		margin-top: 28px;
	}

	.new-event-flight-reservation__button {
		width: 100%;
		max-width: 192px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/flight-reservation/FlightReservation.vue